import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import ErrorMessage from "./../../atoms/ErrorMessage";
import MealItem from "./../../molecules/MealItem";
import MenuPageSkeletonLoader from "./../../molecules/MenuPageSkeleton";
import { getMealsData } from "../../../utils/functions";

import styled from "styled-components";

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: ${(props) => props.theme.sizes.maxWidth};
  margin: 0 auto;
  margin-top: 20px;
  padding-top: 22px;
  padding-bottom: 100px;

  &.reverse {
    flex-direction: column-reverse;
  }

  @media (min-width: 990px) {
    padding-bottom: 80px;
  }

  > div {
    margin-bottom: 25px;
  }
`;

const SectionWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  position: relative;
  margin-top: 40px;

  @media (min-width: 1280px) {
    .meal-item {
      width: 25%;

      &:nth-child(3n + 4)::before {
        display: none;
      }

      &:nth-child(4n + 5)::before {
        display: block;
        content: "";
        position: absolute;
        width: calc(100% - 15px);
        border-top: 1px solid #e6e6e6;
        transform: translate(0, -10px);
      }
    }
  }
`;

function Menu(props) {
  const { mealConstructorCollections } = props;
  const [errorMessage, setErrorMessage] = useState("");
  const [meals, setMeals] = useState([]);

  function filterOutSmoothies(data) {
    let _data = [...data];
    return _data.filter((item) => !item.tags.includes("Smoothie"));
  }

  useEffect(() => {
    getMealsData(mealConstructorCollections).then((data) => {
      const error = data.error;
      if (error.message) {
        setErrorMessage(error.message);
      } else {
        setMeals(filterOutSmoothies(data.constructorData.meals));
      }
    });
  }, [mealConstructorCollections]);

  return (
    <Wrap>
      {errorMessage && <ErrorMessage modalIsOpen={errorMessage.length ? true : false} message={errorMessage} />}

      <SectionWrap>
        {meals.length > 0 &&
          meals.map((meal) => {
            return (
              <MealItem
                id={meal.id}
                excluded={false}
                hidden={false}
                title={meal.title}
                image={meal.image}
                tags={meal.tags}
                key={meal.id}
                variants={meal.variants}
                mealChange={null}
                images={meal.images}
                handle={meal.handle}
                mealBoughtQuantity={meal.mealBoughtQuantity}
                stockCapacity={meal.stockCapacity}
                quantitySelected={0}
                frequence={"recurring"}
                view={"standart"}
                deliveryItem={true}
                charge={null}
                linkToCollection={mealConstructorCollections.mealsCollectionLink}
                mealsCollectionButtonLabel={mealConstructorCollections.mealsCollectionButtonLabel}
              />
            );
          })}
      </SectionWrap>
      {meals.length === 0 && <MenuPageSkeletonLoader />}
    </Wrap>
  );
}

Menu.propTypes = {
  mealConstructorCollections: PropTypes.object,
};

export default Menu;
